<template>
  <v-stepper
    v-model="model"
    flat
    class="transparent"
    :mobile="mobile"
  >
    <v-stepper-header v-show="!hideHeader" style="box-shadow: none">
      <template v-for="({ complete, editable, label, click }, index) in steps" :key="index">
        <v-divider v-if="index" class="mx-2" />

        <v-stepper-item
          :value="index + 1"
          :editable="!!editable"
          :complete="model > index + 1"
          :color="getStepColor(index + 1, complete || index + 1 < model)"
          class="px-0"
          @click="click && click(model)"
        >
          <template #title>
            <span :class="`text-${getStepColor(index + 1, complete || index + 1 < model)}`">
              {{ label }}
            </span>
          </template>
        </v-stepper-item>
      </template>
    </v-stepper-header>
    <v-row :justify="isLastStep ? 'center' : 'space-between'" class="px-6 py-4" style="flex-wrap: nowrap; font-size: 0.95em">
      <v-col v-if="steps[modelValue - 1] !== undefined" cols="5" class="d-flex d-md-none justify-center mt-n2 text-primary">
        {{ steps[modelValue - 1].mobileLabel }}
      </v-col>
      <template v-if="!isLastStep">
        <v-col v-if="!isLastStep" cols="2" class="d-flex d-md-none justify-center mt-n2 text-primary">
          <v-icon color="grey">
            mdi-arrow-right
          </v-icon>
        </v-col>
        <v-col
          v-if="!isLastStep"
          cols="5"
          class="d-flex d-md-none justify-center mt-n2 text-grey text-right"
        >
          {{ steps[modelValue].mobileLabel }}
        </v-col>
      </template>
    </v-row>
    <slot />
  </v-stepper>
</template>

<script setup lang="ts">
import { Step } from "@/types/Step";
import { computed } from "vue";
import { useDisplay } from "vuetify/lib/composables/display";

interface Props {
  steps: Step[];
  modelValue?: number;
  hideHeader?: boolean;
}

const { mobile } = useDisplay();

const props = withDefaults(defineProps<Props>(), {
  modelValue: 1,
  hideHeader: false,
});

const isLastStep = computed((): boolean => {
  return props.modelValue === props.steps.length;
});

const emit = defineEmits<{
  "update:modelValue": [value: number];
}>();

defineOptions({
  name: "TStepper",
});

const model = computed({
  get() {
    return props.modelValue;
  },
  set(step: number) {
    emit("update:modelValue", step);
  },
});

function getStepColor(step: number, complete: boolean): string | undefined {
  if (step === model.value) return "primary";

  if (complete) return "success";

  return;
}
</script>
